// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"f3fefaf8","265":"f3fefaf8","615":"f3fefaf8","629":"9677c181","756":"f3fefaf8","953":"f3fefaf8","978":"9527d92c"}[chunkId] + ".chunk.css";
};